import React from 'react';

export function EventDetailModal({ event, onClose }) {
  if (!event) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-xl max-w-lg w-full overflow-hidden border border-gray-700">
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h3 className="text-lg font-semibold text-gold-400">Booking Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            ✕
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <p className="text-gray-500 text-xs uppercase mb-1">Client</p>
            <p className="text-white text-lg">{event.name}</p>
            <p className="text-gray-400">{event.email}</p>
            <p className="text-gray-400">{event.phone}</p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-gray-500 text-xs uppercase mb-1">Event Date</p>
              <p className="text-white">{event.event_date}</p>
            </div>
            <div>
              <p className="text-gray-500 text-xs uppercase mb-1">Event Type</p>
              <p className="text-white">{event.event_type}</p>
            </div>
          </div>
          <div>
            <p className="text-gray-500 text-xs uppercase mb-1">Location</p>
            <p className="text-white">{event.event_location}</p>
          </div>
          <div>
            <p className="text-gray-500 text-xs uppercase mb-1">Message</p>
            <p className="text-gray-300 whitespace-pre-wrap">{event.message}</p>
          </div>
        </div>
        <div className="p-4 border-t border-gray-700 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
